"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationReminderSendResultDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class RegistrationReminderSendResultDto {}
exports.RegistrationReminderSendResultDto = RegistrationReminderSendResultDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Real (non-internal) Pending users with a valid device token'
}), __metadata("design:type", Number)], RegistrationReminderSendResultDto.prototype, "eligible", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Users actually included in this send after applying the optional limit'
}), __metadata("design:type", Number)], RegistrationReminderSendResultDto.prototype, "sent", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Number of OneSignal batches used for this send'
}), __metadata("design:type", Number)], RegistrationReminderSendResultDto.prototype, "batchCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Pause in milliseconds used between batches'
}), __metadata("design:type", Number)], RegistrationReminderSendResultDto.prototype, "batchIntervalMs", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Optional recipient cap supplied by the admin, if any'
}), __metadata("design:type", Object)], RegistrationReminderSendResultDto.prototype, "limit", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], RegistrationReminderSendResultDto.prototype, "message", void 0);
//# sourceMappingURL=RegistrationReminderSendResult.dto.js.map